import { Team } from "./teams";
export var GroupState;
(function (GroupState) {
    GroupState["Waiting"] = "waiting";
    GroupState["Active"] = "active";
    GroupState["Finished"] = "finished";
    GroupState["Archived"] = "archived";
})(GroupState || (GroupState = {}));
export class NewGroup {
    constructor(name, num_participants, start_time, state, num_slots) {
        this.num_slots = 5;
        this.start_time = null;
        this.name = name;
        this.num_participants = num_participants;
        this.num_slots = num_slots !== null && num_slots !== void 0 ? num_slots : this.num_slots;
        this.start_time = start_time;
        this.state = state;
    }
    get duration() {
        return this.num_slots * 20 * 60;
    }
}
export class Group extends NewGroup {
    // eslint-disable-next-line max-lines-per-function
    constructor(name, num_participants, num_slots, state, start_time, teams, room_preferences, pause_preferences, scheduler_settings) {
        super(name, num_participants, start_time, state, num_slots);
        this.teams = teams;
        this.room_preferences = room_preferences;
        this.pause_preferences = pause_preferences;
        this.scheduler_settings = scheduler_settings;
    }
    static load(data) {
        const teams = {};
        Object.entries(data.teams).forEach(([id, team]) => {
            teams[id] = Team.load(team);
        });
        return new Group(data.name, data.num_participants, data.num_slots, data.state, data.start_time, teams, data.room_preferences, data.pause_preferences, data.scheduler_settings);
    }
    getRoomId(teamId, date) {
        var _a;
        const timestamp = date.getTime() / 1000;
        const team = this.teams[teamId];
        if (team === undefined)
            return null;
        const slot_duration = 20 * 60;
        if (this.start_time === null)
            return null;
        if (timestamp < this.start_time)
            return null;
        const slot = Math.max(Math.floor((timestamp - this.start_time) / slot_duration), 0);
        if (slot >= team.schedule.length)
            return null;
        return (_a = team.schedule[slot]) !== null && _a !== void 0 ? _a : null;
    }
}
